module.exports = __webpack_public_path__ + "static/ms-teams-5323a95bcbba86f91e41f0d896ca89e1.svg";